'use client';

import React, { useEffect, useState } from 'react';
import ImageModal from '@/components/modal/variants/ImageModal';
import { Cookies } from 'react-cookie-consent';
import { usePathname } from 'next/navigation';
import { PopUpBannerProps } from './types';

export default function PopUpBanner(data: PopUpBannerProps) {
  const [isImageModalOpen, setImageModalOpen] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    if (pathname === '/de/energy-air-25_wettbewerb/') {
      return;
    }

    const modalShown = Cookies.get('imageModalShown');
    const targetUrl = data.link?.href;

    // Show only if cookie not set AND current pathname is NOT the same as popup link
    if (!modalShown && pathname !== targetUrl) {
      setImageModalOpen(true);
      Cookies.set('imageModalShown', 'true', { expires: 0.5 });
    }
  }, [data.link?.href, pathname]);

  if (!data) return null;

  return (
    <ImageModal
      isOpen={isImageModalOpen}
      onClose={() => setImageModalOpen(false)}
      ariaLabel="Promotional Image Modal"
      description={data.description}
      image={data.image}
      link={data.link}
      mainHeadline={{
        title: data.title || 'Default title',
        level: 'h2',
        variant: 'headingTwo',
        className: 'text-white',
      }}
    />
  );
}
